// src/pages/Frontpage.js
import React, { useMemo } from "react";
import LaptopImage from "../Images/Laptop.png";
import { useUsers } from "../Commoncontext/UsersContext";
import { useSelectedCompany } from "../Commoncontext/SelectedCompanyContext";
import { Link } from "react-router-dom";
import styles from "../Styles/Frontpage.module.css";
import { useCompanyConfig } from "../Commoncontext/CompanyConfigContext";

function applyTemplate(str, vars) {
  if (!str) return "";
  return String(str)
    .replaceAll("{firstName}", vars.firstName || "")
    .replaceAll("{companyName}", vars.companyName || "");
}

export default function Frontpage() {
  const { user } = useUsers();
  const { selectedCompanyId } = useSelectedCompany();
  const { frontpageConfig } = useCompanyConfig();

  const companyName = useMemo(() => {
    return user?.companyNames?.[selectedCompanyId] || "";
  }, [user, selectedCompanyId]);

  if (!user) return null;

  // fallback jos config puuttuu
  const cfg = frontpageConfig || {};
  const enabled = cfg.enabled !== false;

  const titleTemplate = cfg.titleTemplate || "Hei {firstName}!";
  const subtitleTemplate =
    cfg.subtitleTemplate || "Tervetuloa {companyName} AsukasHuudiin";
  const body =
    cfg.body ||
    "AsukasHuudi on kehitteillä ja ensi vaiheessa asukkaat voivat tehdä yhteisten tilojen varaukset palvelun kautta.\nAsukasHuudia kehitetään ketterästi yhtiön tarpeiden ja asukaspalautteiden pohjalta.";
  const imageUrl = cfg.imageUrl || "";
  const showConsentReminder = cfg.showConsentReminder !== false;

  const title = applyTemplate(titleTemplate, {
    firstName: user.etunimi,
    companyName,
  });

  const subtitle = applyTemplate(subtitleTemplate, {
    firstName: user.etunimi,
    companyName,
  });

  return (
    <main className={styles.content}>
      <div>
        {!enabled ? (
          <h1>Etusivu ei ole käytössä tässä portaalissa.</h1>
        ) : (
          <>
            <h1>{title}</h1>
            <h1>{subtitle}</h1>

            <h3 style={{ whiteSpace: "pre-line" }}>
              {body}
            </h3>

            {showConsentReminder && !user.suostumus && (
              <h3>
                HUOM: Käyttääksesi palvelua, käy ensin hyväksymässä tietosuojaseloste{" "}
                <Link to="/consent" className={styles.link}>
                  täältä
                </Link>
                .
              </h3>
            )}

            <div className={styles.laptopcontent}>
              <img
                src={imageUrl || LaptopImage}
                className={styles.laptopimage}
                alt="Etusivun kuva"
              />
            </div>
          </>
        )}
      </div>
    </main>
  );
}
